import { Link, useLocation, matchPath } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { IRoute } from '../../../routes';
import { closeSideMenu } from '../../../store/sideMenu.slice';
import { NavItem } from '../styles';

type TProps = {
  routes: IRoute;
  routesTo?: string;
  isMenuOpen?: boolean;
  dropdownIcon?: never;
  isDropdownOpen?: never;
  dropdownTitle?: never;
  handleDropdownState?: never;
  dropdownId?: never;
  className?: string;
  count?: number;
  onClick?: () => void;
};

function SideBarItem({ routes, routesTo, className, count, onClick }: TProps) {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  
  const isActive = useMemo(() => {
    // Check if URL contains team_id parameter in events routes by checking URL structure
    const pathSegments = pathname.split('/').filter(Boolean);
    let isTeamEvent = false;

    // Check various patterns for team events
    if (pathSegments[0] === 'events') {
      // Pattern: /events/123 (team_id right after events)
      if (pathSegments.length === 2 && /^\d+$/.test(pathSegments[1])) {
        isTeamEvent = true;
      }
      // Pattern: /events/add-event/123
      else if (pathSegments[1] === 'add-event' && pathSegments.length === 3 && /^\d+$/.test(pathSegments[2])) {
        isTeamEvent = true;
      }
      // Pattern: /events/add-event/one-to-one/123 (or one-to-group, tour, collective)
      else if (pathSegments[1] === 'add-event' && pathSegments.length === 4 && /^\d+$/.test(pathSegments[3])) {
        isTeamEvent = true;
      }
      // Pattern: /events/edit/one_to_one/456/123 (last segment is team_id)
      else if (pathSegments[1] === 'edit' && pathSegments.length === 5 && /^\d+$/.test(pathSegments[4])) {
        isTeamEvent = true;
      }
    }

    // Extract the base path (before any parameters like :team_id?)
    const basePath = routes.path.split('/')[0].split(':')[0];
    const pathnameFirstSegment = pathname.split('/')[1];

    // Check if pathname starts with the base path or matches the route pattern
    let active = pathnameFirstSegment === basePath || matchPath(`/${routes.path}`, pathname) !== null;

    // If we're on a team event page
    if (isTeamEvent) {
      // Highlight teams module, not events
      if (routes.path === 'teams') {
        active = true;
      } else if (basePath === 'events') {
        active = false;
      }
    } else if (routes.path === 'teams') {
      // Teams is only active if we're on the teams route itself (or team events, handled above)
      active = pathnameFirstSegment === 'teams';
    }

    return active;
  }, [pathname, routes.path]);

  const handleLinkClick = () => {
    if (onClick) {
      onClick(); // Call the onClick function if it's provided
    }
    dispatch(closeSideMenu());
  };

  return (
    <NavItem className={className} activeLink={isActive}>
      <Link to={routesTo || routes.to()} onClick={handleLinkClick}>
        <div>{routes.icon}</div>
        {routes.sidebarTitle && <p>{routes.sidebarTitle()}</p>}
      </Link>
      {count ? <span className="count">{count}</span> : null}
    </NavItem>
  );
}

export default SideBarItem;
